import { FC } from "react";
import image from "../../Assets/AIOnDemand/automation-hero.png";
import stroke from "../../Assets/AIOnDemand/green-stroke.png";
import bgImage from "../../Assets/homev2/el-bg.png";
const AutomationHero: FC = () => {
    return (
        <section
            className="w-full bg-cover bg-no-repeat bg-bottom overflow-hidden relative mb-2 lg:mb-10"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="w-full h-full max-w-[1500px] mx-auto px-4 pt-8 md:pt-20 flex flex-col justify-between gap-4 lg:gap-8 items-center">
                <div className="w-full">
                    <h2 className="text-2xl flex flex-row items-center justify-center gap-4 md:text-5xl lg:text-7xl text-black font-semibold text-center">
                        Revenue AI Agents & Workflows<br />
                        From Start to Finish
                    </h2>
                    <img src={stroke} alt="green swish" className="max-w-[200px] md:max-w-none mx-auto" />
                </div>
                <div className=" relative max-w-[1700px] mt-5 lg:px-10 lg:mt-16">
                    <img
                        src={image}
                        alt="Customize my solution"
                        width="100%"
                        height="100%"
                        loading="lazy"
                        className="object-contain"
                    />
                </div>
            </div>

        </section>
    );
};

export default AutomationHero;
